import { render, staticRenderFns } from "./modalDetalles.vue?vue&type=template&id=65a89976"
import script from "./modalDetalles.vue?vue&type=script&lang=js"
export * from "./modalDetalles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports